module.exports = __webpack_public_path__ + "static/media/confirmed_pass.578cc138.svg";